import { PageHeaderSubtitle } from './type';

export const pageHeaderSubtitleSettings: PageHeaderSubtitle = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        regular: {
          color: 'black.main',
        },
      },
    },
  },
};
